module.exports = __webpack_public_path__ + "img/Semaforo2.6a82d393.svg";